import React, { FC, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';

import { clearSearchParams, setSearchParam } from 'src/utils/url';
import { addDOMClass, removeDOMClass } from 'src/utils/DOM';
import { CSS_ANIMATION_DURATION } from 'src/config';
import { ChildrenPropType } from 'src/utils/types';

type Props = {
  show: boolean;
  id: number | null | undefined;
  onClose: () => void;
  children: (close: () => void) => ChildrenPropType;

  searchParam?: string;
  containerId?: string;
};

/**
 * closes only when click either on a background or at close button (not useRefClickOutside because of inner modals)
 */
export const Overlay: FC<Props> = ({ show, id, searchParam, onClose, children, containerId }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const bodyClass = 'y-scrolling-disabled';

    if (show) {
      if (searchParam) {
        setSearchParam({
          [searchParam]: id,
        });
      }

      setTimeout(() => {
        setAnimate(true);
      }, 10);

      addDOMClass('body', bodyClass);
    }

    return () => {
      if (searchParam) {
        clearSearchParams([searchParam]);
      }

      removeDOMClass('body', bodyClass);
    };
  }, [id, show, searchParam]);

  const close = useCallback(() => {
    setAnimate(false);

    setTimeout(() => {
      onClose();
    }, CSS_ANIMATION_DURATION / 2);
  }, [onClose]);

  return show ? (
    <>
      <div
        id={containerId}
        className={classNames('sliding-overlay campaigns-layout-container', {
          'sliding-overlay-expanded': animate,
          'sliding-overlay-collapsed': !animate,
        })}
      >
        <div className="sliding-overlay-container">{children(close)}</div>
      </div>
      <div role="presentation" className="animated fadeIn r-overlay" onClick={close} />
    </>
  ) : null;
};
